import React, { useEffect, useState, useContext } from 'react';
import { svgSprite } from '../../../hybrid/wrappers';
import { getStylePropsFunc } from '../../../common/utils/styles';
import T from '../../../common/components/T';
import UserContext from '../../../common/utils/getContext';
import { getWidgetTranslates } from '../../../common/utils/utils';
import { LangContext } from '../../../common/decorators/Language';

const SearchBlockMob = ({ compStyles, textsData, closeModal, translates }) => {
    const [transl, setTranslates] = useState(translates);
    const { translation } = useContext(LangContext);
    const { lang } = useContext(UserContext);
    useEffect(() => {
        if (translates) {
            setTranslates(translates);
        } else {
            getWidgetTranslates(lang, 'gridFilter', translation, setTranslates);
        }
    }, [lang, translation, translates]);

    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    return (
        <div {...getStyleProps('adminFilterWindowTitleHeading')}>
            <div {...getStyleProps('adminFilterWindowHeadingclose')} onClick={closeModal}>
                {svgSprite('arrow-left', getStyleProps('adminFilterWindowHeadingcloseSvg'))}
            </div>
            <div {...getStyleProps('adminFilterWindowHeadingTitle')}>
                <p>
                    {textsData.filterTitleSmall || (
                        <T
                            customTranslates={transl}
                            customLoading={!transl}
                            group='gridFilter'
                            textName='filterTitleSmall'
                            defaultStr='Поиск'
                            page='widget'
                        />
                    )}
                </p>
            </div>
        </div>
    );
};
export default SearchBlockMob;
